import Lightbox from "react-image-lightbox";
import React from "react";
import {BaseComponent} from '@cm-sites-webber/components';
export default class ImageView extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }

    show = () => {
        this.setState({ isOpen: true });
    };

    hide = () => {
        this.setState({ isOpen: false });
    };

    render() {
        const { isOpen } = this.state;
        return (
            <div>
                {isOpen && (
                    <Lightbox
                        mainSrc={this.props.path}
                        onCloseRequest={this.hide}
                    />
                )}
            </div>
        );
    }
}